import { Moment } from 'moment-timezone';
import styles from './BoardingCheckMoment.module.scss';
import { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlarmExclamation } from '@fortawesome/pro-light-svg-icons';

interface BoardingCheckMomentProps {
    moment: Moment;
    pendingDropOff?: boolean;
    className?: string;
}
export const BoardingCheckMoment: FunctionComponent<BoardingCheckMomentProps> = props => {
    const alarm = props.pendingDropOff ? (
        <FontAwesomeIcon
            icon={faAlarmExclamation}
            className={styles.alarm}
        />
    ) : null;

    return (
        <div className={styles.container}>
            <span className={styles.date}>{props.moment.clone().format('MMM D, YYYY')}</span>
            <div className={styles.row}>
                <span className={styles.time}>{props.moment.clone().format('h:mma')}</span>
                {alarm}
            </div>
        </div>
    );
};

export default BoardingCheckMoment;
